module.exports = __webpack_public_path__ + "static/img/icon1.732e68c0.gif";